import { z } from "zod";

// Absences may start on any date (past included). Only sanity checks: reason present/length, end >= start.
export const absenceSchema = z
  .object({
    startDate: z.string().min(1, "Välj ett startdatum"),
    endDate: z.string().min(1, "Välj ett slutdatum"),
    reason: z
      .string()
      .trim()
      .min(1, "En anledning krävs")
      .max(500, "Högst 500 tecken"),
  })
  .refine((v) => v.endDate >= v.startDate, {
    path: ["endDate"],
    message: "Slutdatum får inte vara före startdatum",
  });
export type AbsenceFormInput = z.input<typeof absenceSchema>;
export type AbsenceFormValues = z.output<typeof absenceSchema>;
